import React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import { graphql } from "gatsby"
import ServiceHeader from "../../components/common/ServiceHeader"
import DescriptionComponent from "../../components/ServicesPage/RentPage/DescriptionComponent"
import { useTranslation } from "react-i18next"
import rentBackground from "../../assets/images/rent-background.jpg"

const RentPage: React.FC = () => {
  const {t} = useTranslation('index', {
    keyPrefix: 'pages.services-rent',
  })

  return (
    <Layout>
      <Seo title={t('seo.title')} />
      <ServiceHeader 
        backgroundImage={rentBackground}
        title={t('slider1')}
        subtitle={t('slider2')}
      />
      <DescriptionComponent
        field1={[t('field1.paragraph1'),t('field1.paragraph2'),t('field1.paragraph3')]}
        field2={[t('field2.paragraph1'),t('field2.paragraph2'),t('field2.paragraph3')]}
        button1={t('button1')}
        button2={t('button2')}
      />
    </Layout>
  )
}

export default RentPage

export const query = graphql`
  query {
    locales: allLocale {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
